export const TIMING_OPTIONS = [
  { value: 'flexible', label: "I'm flexible" },
  { value: 'next_couple_of_weeks', label: 'In the next few weeks' },
  { value: 'asap_urgent', label: 'Urgently' },
  { value: 'on_a_particular_date', label: 'On a particular date' },
]

export const MIN_DESCRIPTION_LENGTH = 20

// Matches Attachments::Create (API V2) file_size: less_than 20.megabytes.
// No server-side cap on attachment count for job uploads via this path.
export const JOB_ATTACHMENT_MAX_SIZE_MB = 20
export const JOB_ATTACHMENT_MAX_SIZE_BYTES = JOB_ATTACHMENT_MAX_SIZE_MB * 1024 * 1024
export const JOB_ATTACHMENT_OVERSIZE_MESSAGE = `One or more files exceed the ${JOB_ATTACHMENT_MAX_SIZE_MB} MB size limit. Please select smaller files.`
export const JOB_ATTACHMENT_UNSUPPORTED_MESSAGE = 'One or more files you selected are unsupported. Please select .pdf, .jpg, .jpeg, or .png image files.'

const DQR_MASKED_PHONE_PLACEHOLDER = '04** *** ***'

/** Mask a business mobile for display when the viewer must not see the full number (e.g. logged-out viewer). */
export const maskBusinessPhoneForDisplay = (phone) => {
  if (!phone) return null

  const digits = phone.replace(/\D/g, '')
  if (digits.length < 2) return DQR_MASKED_PHONE_PLACEHOLDER

  return phone.slice(0, 2) + phone.slice(2).replace(/\d/g, '*')
}

export const formatRespondsLabel = (responseTime) => {
  let phrase = (responseTime || 'Within minutes').trim().replace(/^within\b/i, 'in')

  if (!/^in\b/i.test(phrase)) {
    phrase = `in ${phrase}`
  }

  return `Responds ${phrase}`
}

export const DQR_MODAL_MAX_WIDTH_WITH_SIDEBAR_CLASS =
  'max-w-full md:max-w-[704px] lg:max-w-[984px]'

export const DQR_MODAL_MAX_WIDTH_ACCOUNT_ONLY_CLASS =
  'max-w-full lg:max-w-[700px]'

export const DQR_SUBCATEGORY_SELECTION_ERROR =
  'Please select a service from the list.'

export const DQR_SUBURB_SELECTION_ERROR =
  'Please select a suburb or postcode from the list.'

export const dqrSubcategoryServiceabilityError = (businessName) => (
  'Category not offered. Try another category or business.'
)

export const dqrSuburbServiceabilityError = (businessName) => (
  'Location not serviced. Try another location or business.'
)

export const HELP_CENTRE_FAQ_URL = 'https://www.serviceseeking.com.au/knowledge'
